import {
    FETCH_FEATURES_ERROR,
    FETCH_FEATURES_IN_PROGRESS,
    FETCH_FEATURES_SUCCESS,
    FETCH_OWNER_COLLECTIONS_ERROR,
    FETCH_OWNER_COLLECTIONS_IN_PROGRESS,
    FETCH_OWNER_COLLECTIONS_SUCCESS,
    FETCH_OWNER_LISTINGS_ERROR,
    FETCH_OWNER_LISTINGS_IN_PROGRESS,
    FETCH_OWNER_LISTINGS_SUCCESS,
    FETCH_OWNER_NFT_S_ERROR,
    FETCH_OWNER_NFT_S_IN_PROGRESS,
    FETCH_OWNER_NFT_S_SUCCESS,
} from '../constants/navBar';
import { urlFeatures, urlOwnerCollections, urlOwnerListings, urlOwnerNFTs } from '../constants/url';
import Axios from 'axios';
import { handleErrorMessage } from '../utils/errorMessages';

const fetchOwnerCollectionsInProgress = () => {
    return {
        type: FETCH_OWNER_COLLECTIONS_IN_PROGRESS,
    };
};

const fetchOwnerCollectionsSuccess = (result, count) => {
    return {
        type: FETCH_OWNER_COLLECTIONS_SUCCESS,
        result,
        count,
    };
};

const fetchOwnerCollectionsError = (message) => {
    return {
        type: FETCH_OWNER_COLLECTIONS_ERROR,
        message,
    };
};

export const fetchOwnerCollections = (address) => (dispatch) => {
    dispatch(fetchOwnerCollectionsInProgress());

    const url = urlOwnerCollections(address);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    }).then((res) => {
        if (res && res.data && res.data.result && res.data.result) {
            dispatch(fetchOwnerCollectionsSuccess(res.data && res.data.result.list, res.data && res.data.result.count));
        }
    }).catch((error) => {
        const message = handleErrorMessage(error);
        dispatch(fetchOwnerCollectionsError(message));
    });
};

const fetchOwnerNFTsInProgress = () => {
    return {
        type: FETCH_OWNER_NFT_S_IN_PROGRESS,
    };
};

const fetchOwnerNFTsSuccess = (result, count) => {
    return {
        type: FETCH_OWNER_NFT_S_SUCCESS,
        result,
        count,
    };
};

const fetchOwnerNFTsError = (message) => {
    return {
        type: FETCH_OWNER_NFT_S_ERROR,
        message,
    };
};

export const fetchOwnerNFTs = (address) => (dispatch) => {
    dispatch(fetchOwnerNFTsInProgress());

    const url = urlOwnerNFTs(address);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    }).then((res) => {
        if (res && res.data && res.data.result && res.data.result) {
            dispatch(fetchOwnerNFTsSuccess(res.data && res.data.result.list, res.data && res.data.result.count));
        }
    }).catch((error) => {
        const message = handleErrorMessage(error);
        dispatch(fetchOwnerNFTsError(message));
    });
};

const fetchOwnerListingsInProgress = () => {
    return {
        type: FETCH_OWNER_LISTINGS_IN_PROGRESS,
    };
};

const fetchOwnerListingsSuccess = (result, count) => {
    return {
        type: FETCH_OWNER_LISTINGS_SUCCESS,
        result,
        count,
    };
};

const fetchOwnerListingsError = (message) => {
    return {
        type: FETCH_OWNER_LISTINGS_ERROR,
        message,
    };
};

export const fetchOwnerListings = (address) => (dispatch) => {
    dispatch(fetchOwnerListingsInProgress());

    const url = urlOwnerListings(address);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    }).then((res) => {
        if (res && res.data && res.data.result && res.data.result) {
            dispatch(fetchOwnerListingsSuccess(res.data && res.data.result.list, res.data && res.data.result.count));
        }
    }).catch((error) => {
        const message = handleErrorMessage(error);
        dispatch(fetchOwnerListingsError(message));
    });
};

const fetchFeaturesInProgress = () => {
    return {
        type: FETCH_FEATURES_IN_PROGRESS,
    };
};

const fetchFeaturesSuccess = (result, count) => {
    return {
        type: FETCH_FEATURES_SUCCESS,
        result,
        count,
    };
};

const fetchFeaturesError = (message) => {
    return {
        type: FETCH_FEATURES_ERROR,
        message,
    };
};

export const fetchFeatures = (address) => (dispatch) => {
    dispatch(fetchFeaturesInProgress());

    const url = urlFeatures(address);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    }).then((res) => {
        if (res && res.data && res.data.result && res.data.result) {
            dispatch(fetchFeaturesSuccess(res.data && res.data.result.list, res.data && res.data.result.count));
        }
    }).catch((error) => {
        const message = handleErrorMessage(error);
        dispatch(fetchFeaturesError(message));
    });
};
